import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZData = z.object({
  is_asset_online: z.boolean(),
  communication_time: z.string(),
  communication_status: z.string()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.optional(ZData)
})

export type DeviceStatusOnlineDetails = z.infer<typeof ZData>
export type getDeviceStatusOnlineAPIData = z.infer<typeof ZApiResponse>

export async function getDeviceStatusOnlineService (
  deviceId: string,
  onSuccess: (DeviceStatusOnlineDetails: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/assetrest/api/v2/udp/tiq/assets/communicationStatus/${deviceId}`
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
